export default __webpack_public_path__ + "static/media/medicare-nopractitioner.849ecfe3.svg";